import axios from "axios"
import baseURL from "../configs/api"

export const getCountries = (tenantId: string) => {
    return getFetch("country", tenantId)
}

export const getCountry = (primaryKey: string, tenantId: string) => {
    return getFetch(`country/${primaryKey}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}